export class HeaderConstants {
  public static AUTHORIZATION = 'authorization';
  public static XBS_CONTAINER_UUID = 'xbscontaineruuid';
  public static XBS_PRODUCT_ID = 'xbsproductid';
  public static XBS_PRODUCT_UUID = 'xbsproductuuid';
  public static XBS_ROLE_UUID = 'xbsroleuuid';
  public static XBS_USER_UUID = 'xbsuseruuid';
  public static XBS_IS_NEW_UI = 'xbsisnewui';
  public static XBS_ORIGIN_URL = 'xbsoriginurl';
}
